import { MenuButton } from "@szhsin/react-menu";

import cn from "@utils/cn";
import { getIconProps } from "@utils";
import Icon from "@elements/Icon";
import Avatar from "@elements/Avatar";

const CLASS_NAMES = cn(`
  flex
  items-center
  justify-start
  h-navbar-height
  gap-2
  px-4
  text-base
  font-medium
  tracking-wide
  outline-hidden
  cursor-pointer
  select-none
  transition-all
  duration-200

  text-white
  ring-0

  hover:bg-(--navbar-menu-hover-background-color)
  hover:[--icon-background-color:var(--navbar-menu-hover-background-color)]

  focus:bg-(--navbar-menu-focus-background-color)
  focus:[--icon-background-color:var(--navbar-menu-focus-background-color)]
  focus:ring-0
  focus:outline-hidden

  active:bg-(--navbar-menu-focus-background-color)
  active:[--icon-background-color:var(--navbar-menu-focus-background-color)]
  active:ring-0
  active:outline-hidden

  data-[selected=true]:bg-(--navbar-menu-active-background-color)
  data-[selected=true]:text-white
  data-[selected=true]:[--icon-background-color:var(--navbar-menu-active-background-color)]
`);

export default function NavbarMenuButton(props) {
  const {
    label,
    anchorRef,
    anchorProps,
    isOpen,
  } = props;

  const {
    text,
    imageUrl,
  } = label;

  const iconProps = getIconProps(label.icon);

  /**************************************************************************************************/

  return (
    <MenuButton
      className={CLASS_NAMES}
      ref={anchorRef}
      data-selected={isOpen}
      {...anchorProps}
    >
      {iconProps && (
        <Icon {...iconProps} />
      )}

      {imageUrl && (
        <Avatar
          className="visible-when-not-mobile"
          size="1.5rem"
          url={imageUrl}
        />
      )}

      {text}

      <Icon
        iconName="chevron-down"
        color="white"
        size="xs"
      />
    </MenuButton>
  );
}
